import { z } from "zod"
import { type TerritorialTargetType, TerritorialTargetSchema } from "@antipartido-inc/contracts-ifaces"

const TerritorialTargetValidation = z.object({
  entidadClave: z.number().int().min(1).max(32),
  distritoClave: z.number().int().min(1).optional(),
  municipioClave: z.number().int().min(1).optional(),
  seccion: z.number().int().min(1).optional(),
})

export class TerritorialTarget {
  constructor(
    private readonly _entidadClave: number,
    private readonly _distritoClave?: number,
    private readonly _municipioClave?: number,
    private readonly _seccion?: number,
  ) {}

  static create({ entidadClave, distritoClave, municipioClave, seccion }: z.infer<typeof TerritorialTargetValidation>) {
    const { success, error } = TerritorialTargetValidation.safeParse({
      entidadClave,
      distritoClave,
      municipioClave,
      seccion,
    })
    if (!success) throw new Error(error.message)
    return new TerritorialTarget(entidadClave, distritoClave, municipioClave, seccion)
  }

  static createFromAPI({ entidadClave, distritoClave, municipioClave, seccion }: TerritorialTargetType) {
    const { success, error } = TerritorialTargetSchema.safeParse({
      entidadClave,
      distritoClave,
      municipioClave,
      seccion,
    })
    if (!success) throw new Error(error.message)

    return TerritorialTarget.create({
      entidadClave,
      distritoClave: distritoClave ?? undefined,
      municipioClave: municipioClave ?? undefined,
      seccion: seccion ?? undefined,
    })
  }

  get entidadClave() { return this._entidadClave } // prettier-ignore
  get distritoClave() { return this._distritoClave } // prettier-ignore
  get municipioClave() { return this._municipioClave } // prettier-ignore
  get seccion() { return this._seccion } // prettier-ignore

  serialize(): { entidadClave: number; distritoClave?: number; municipioClave?: number; seccion?: number } {
    return {
      entidadClave: this.entidadClave,
      distritoClave: this.distritoClave,
      municipioClave: this.municipioClave,
      seccion: this.seccion,
    }
  }
}

export type TerritorialTargetSerialized = ReturnType<TerritorialTarget["serialize"]>
